import { DiagramValidationErrorModel } from "../config/DiagramValidationErrorModel";
import { DIAGRAM_ERROR_TYPES } from "../config/DiagramErrorTypes";

export function DiagramUnconnectedPluginsCheck(data) {
    const isValid = data.parsedPlugins.length === data.diagramData.content.length;
    if (!isValid) {
        return [
            new DiagramValidationErrorModel({
                type: DIAGRAM_ERROR_TYPES.UNCONNECTED_PLUGINS,
                reason: "Diagram has unconnect plugins to the main plugin nodes!",
                aditional: { unconnectedPlugins: data.diagramData.content.length - data.parsedPlugins.length }
            })
        ];
    }
    return true;
}
